export default __webpack_public_path__ + "static/media/Maths_tutoring.91d99d50.jpg";